module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/core-js/object/assign.js
// module id = 3212
// module chunks = 0